import axios from "axios";
//import axiosRetry from "axios-retry";

// Tunneled dev (phone / WeChat in-app browser): frontend and backend are on
// separate public hosts, so point every API call at the backend's public URL.
// Paste your cloudflared backend URL here when phone-testing; "" = off.
// (Not a secret — it's a public URL. Don't commit a live value.)
const API_BASE_OVERRIDE = "";

axios.defaults.baseURL = "/api/";
if (API_BASE_OVERRIDE) {
  axios.defaults.baseURL = API_BASE_OVERRIDE;
} else if (location.hostname === "localhost") {
  axios.defaults.baseURL = "http://localhost:3000";
}
axios.defaults.timeout = 600000;

export function createClient(token) {
  const instance = axios.create({
    headers: {
      token: token,
    },
  });

  //axiosRetry(instance, { retryDelay: axiosRetry.exponentialDelay });

  instance.interceptors.response.use((value) => {
    return value.data;
  });

  // Add streaming method for Server-Sent Events
  instance.postEventStream = async (url, data, options = {}) => {
    const baseURL = axios.defaults.baseURL.replace(/\/+$/, "");
    const fullUrl = baseURL + (url.startsWith("/") ? url : "/" + url);
    
    return fetch(fullUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "token": token,
        ...options.headers
      },
      body: JSON.stringify(data),
      signal: options.signal,
    });
  };

  return instance;
}
